import { useQuery } from '@tanstack/react-query'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getRentersPolicy } from '@/services/renters.services'
import {
  RENTERS_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type { RentersPolicy } from '@/shared/types/global.types'

export function useRentersPolicy(enabled: boolean = true) {
  return useQuery<RentersPolicy[]>({
    queryKey: RENTERS_QUERY_KEYS.policies,
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getRentersPolicy(token)
    },
    enabled,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
